export default {
  namespaced: true,
  state: {
    currentlyEditedOptions: []
  },
  mutations: {
    setCurrentlyEditedOptions(state, data) {
      state.currentlyEditedOptions = data
    }
  },
  actions: {
    getAttributesOptionsList({ dispatch, commit }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesOptions.getList',
          payload
        },
        { root: true }
      )
        .then((response) => {
          commit('setCurrentlyEditedOptions', response.data)
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    createAttributesOption({ dispatch }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesOptions.create',
          payload
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    updateAttributesOption({ dispatch }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesOptions.update',
          payload
        },
        { root: true }
      )
        .then((response) => {
          return response.data
        })
        .catch((e) => {
          throw e
        })
    },
    deleteAttributesOption({ dispatch }, payload) {
      return dispatch(
        'app/makeCall',
        {
          route: 'attributesOptions.delete',
          payload
        },
        { root: true }
      )
        .then(() => {})
        .catch((e) => {
          throw e
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/attributes-options.js